// extracted by mini-css-extract-plugin
export default {"options_parent":"SearchBar_options_parent__x2u5u","options_box":"SearchBar_options_box__fnv6B"};